Vue.component('content-social', {
    delimiters: ['[[', ']]'],
    template: `
        <div class="container">
            <div class="row d-flex flex-wrap align-items-center">
                <div class="lqd-column col-md-6 d-flex flex-wrap align-items-center">
                    <figure class="mr-3">
                        <img :src="path+ '/assets/img/spartaquant/icon-color.png'" width="60px" alt="SpartaQuant Icon">
                    </figure>
                    <p class="font-size-16 my-0"><span class="text-secondary font-weight-bold" style='color:black !important'><span class="sq-font">SpartaQuant</span> [[ currentYear ]] &copy;</span> All Rights Reserved.</p>
                </div>
                
                <div class="lqd-column col-md-5 text-md-right">
                    
                    <!-- <ul class="social-icon social-icon-md mb-25">
                        <li><a href="#" target="_blank"><i class="fa fa-facebook"></i></a></li>
                        <li><a href="#" target="_blank"><i class="fa fa-twitter"></i></a></li>
                        <li><a href="#" target="_blank"><i class="fa fa-linkedin"></i></a></li>
                    </ul> -->

                </div>

            </div>
        </div>
    `,
    props: {
        idcomponent: {
            type: String,
            default: 'menu'
        },
        path: {
            type: String,
            default: ''
        },
    },
    data: function () {
        return {
            menuType: 1,
            currentYear:'',
        }
    },
    mounted(){
        this.currentYear = new Date().getFullYear();
    },
    methods: {

    },
});